<div
  class="discount-widget"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div #triggerBadge class="discount-trigger-badge">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="tag-icon-svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path
        d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
      ></path>
      <line x1="7" y1="7" x2="7.01" y2="7"></line>
    </svg>
    <span>{{ savePercent }}%</span>
  </div>

  <div
    class="discount-popup"
    [class.show-popup]="isHovered"
    [class.placement-bottom]="placement === 'bottom'"
  >
    <div class="popup-row">
      <span>{{ originalText }}: </span>
      <span class="old-price">{{
        originalPrice
          | currency : displayCurrency.code : displayCurrency.symbol : "1.2"
      }}</span>
    </div>
    <div class="popup-row final-price-row">
      <span class="mr-1">{{ saleText }}: </span>
      <span class="final-price">{{
        salePrice
          | currency : displayCurrency.code : displayCurrency.symbol : "1.2"
      }}</span>
    </div>
    <div class="saved-row">
      Discounted
      {{
        savePrice
          | currency : displayCurrency.code : displayCurrency.symbol : "1.2"
      }}!
    </div>
  </div>
</div>
